// Legacy export format because this is used by some build-time scripts stuck in the past.
// eslint-disable-next-line import/no-commonjs
module.exports = {
    APP_VERSION: '1.2.6',
    DESKTOP_VERSION: '1.2.6'
};
